import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const Mill_DB= Cookies.get("YearDatabase");

const extractErrorMessage = (error) => {
    if (error.response && error.response.data) {
        if (typeof error.response.data === 'string') {
            return error.response.data;
        }
        if (error.response.data.message) {
            return error.response.data.message;
        }
        if (error.response.data.error) {
            return error.response.data.error;
        }
        return JSON.stringify(error.response.data);
    }
    return error.message || 'Network Error';
};

export const GetSubUsers = createAsyncThunk(
    'UserRight/GetSubUsers',
    async (_, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const response = await axios.get(`${BaseURL}/ClientUser/Get_SubUsers`, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(extractErrorMessage(error));
        }
    }
);

export const AddSubUser = createAsyncThunk(
    'UserRight/AddSubUser',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const token = Cookies.get('authToken');
            const response = await axios.post(`${BaseURL}/ClientUser/Add_SubUser`, data, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            dispatch(GetSubUsers());
            return response.data;
        } catch (error) {
            return rejectWithValue(extractErrorMessage(error));
        }
    }
);

export const UpdateSubUser = createAsyncThunk(
    'UserRight/UpdateSubUser',
    async ({ id, data }, { rejectWithValue, dispatch }) => {
        try {
            const token = Cookies.get('authToken');
            const response = await axios.post(`${BaseURL}/ClientUser/Update_SubUser/${id}`, data, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            dispatch(GetSubUsers());
            return response.data;
        } catch (error) {
            return rejectWithValue(extractErrorMessage(error));
        }
    }
);

export const DeleteSubUser = createAsyncThunk(
    'UserRight/DeleteSubUser',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const token = Cookies.get('authToken');
            const response = await axios.post(`${BaseURL}/ClientUser/Delete_SubUser/${id}`, {}, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            dispatch(GetSubUsers());
            return response.data;
        } catch (error) {
            return rejectWithValue(extractErrorMessage(error));
        }
    }
);

export const SaveCustomMenu = createAsyncThunk(
    'UserRight/SaveCustomMenu',
    async (customMenu, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const response = await axios.post(`${BaseURL}/ClientUser/SaveCustomMenu`, { customMenu }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(extractErrorMessage(error));
        }
    }
);

export const GetCustomMenu = createAsyncThunk(
    'UserRight/GetCustomMenu',
    async (_, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const response = await axios.get(`${BaseURL}/ClientUser/GetCustomMenu`, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(extractErrorMessage(error));
        }
    }
);

export const GetSqlUsers = createAsyncThunk(
    'UserRight/GetSqlUsers',
    async (database, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const response = await axios.post(`${BaseURL}/UserRight/CustomerUserRight`, {
                DataBase: database,
                MillDataBase:Mill_DB
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(extractErrorMessage(error));
        }
    }
);

const userRightSlice = createSlice({
    name: 'UserRight',
    initialState: {
        subUsers: [],
        sqlUsers: [],
        sqlUsersData1: [],
        sqlUsersData2: [],
        customMenu: [],
        customMenuLoading: false,
        sqlUsersLoading: false,
        loading: false,
        error: null,
        successMessage: null
    },
    reducers: {
        clearMessages: (state) => {
            state.successMessage = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // GetSubUsers
            .addCase(GetSubUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSubUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.subUsers = action.payload.data || [];
            })
            .addCase(GetSubUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // AddSubUser
            .addCase(AddSubUser.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(AddSubUser.fulfilled, (state, action) => {
                state.loading = false;
                state.successMessage = action.payload.message || 'Sub-user created successfully';
            })
            .addCase(AddSubUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // UpdateSubUser
            .addCase(UpdateSubUser.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(UpdateSubUser.fulfilled, (state, action) => {
                state.loading = false;
                state.successMessage = action.payload.message || 'Sub-user updated successfully';
            })
            .addCase(UpdateSubUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // DeleteSubUser
            .addCase(DeleteSubUser.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(DeleteSubUser.fulfilled, (state, action) => {
                state.loading = false;
                state.successMessage = action.payload.message || 'Sub-user deleted successfully';
            })
            .addCase(DeleteSubUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // GetSqlUsers
            .addCase(GetSqlUsers.pending, (state) => {
                state.sqlUsersLoading = true;
                state.error = null;
            })
            .addCase(GetSqlUsers.fulfilled, (state, action) => {
                state.sqlUsersLoading = false;
                state.sqlUsers = action.payload.Data || [];
                state.sqlUsersData1 = action.payload.Data1 || [];
                state.sqlUsersData2 = action.payload.Data2 || [];
            })
            .addCase(GetSqlUsers.rejected, (state, action) => {
                state.sqlUsersLoading = false;
                state.error = action.payload;
            })

            // SaveCustomMenu
            .addCase(SaveCustomMenu.pending, (state) => {
                state.customMenuLoading = true;
            })
            .addCase(SaveCustomMenu.fulfilled, (state, action) => {
                state.customMenuLoading = false;
                state.customMenu = action.payload.data || [];
                state.successMessage = 'Custom menu saved successfully';
            })
            .addCase(SaveCustomMenu.rejected, (state, action) => {
                state.customMenuLoading = false;
                state.error = action.payload;
            })

            // GetCustomMenu
            .addCase(GetCustomMenu.pending, (state) => {
                state.customMenuLoading = true;
            })
            .addCase(GetCustomMenu.fulfilled, (state, action) => {
                state.customMenuLoading = false;
                state.customMenu = action.payload.data || [];
            })
            .addCase(GetCustomMenu.rejected, (state, action) => {
                state.customMenuLoading = false;
                state.error = action.payload;
            });

    }
});

export const { clearMessages } = userRightSlice.actions;
export default userRightSlice.reducer;
